module.exports = {"reviews":{"general":{"see_more":"+ See More","ago":"ago","reviews":"Reviews"},"header":{"title":"Reviews"},"users":{"user_show":{"reviews_not_found":"There are currently no %{type}..."},"show":{"reviewed_by":"Reviewed by","seller_feedback":"Seller's Feedback"}},"gigs":{"_inner_gig":{"drop_most_recent":"Most Recent","drop_positive":"Positive Reviews","drop_negative":"Negative Reviews"},"_rating":{"q1":"Seller communication level","q2":"Service as described","q3":"Recommend to a friend"}},"returning_buyer":"Returning Buyer"}}


//////////////////
// WEBPACK FOOTER
// ./src/translations.en.json
// module id = eIBB
// module chunks = 0